import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';

import Results from '~/components/search/results/results';
import { getLoads } from '~/modules/alert/actions';
import css from './index.css';
import cs from 'classnames';
import Spinner from '~/components/common/Spinner';

class AlertLoads extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    this.props.getLoads(this.props.params);
  }
  render() {
    const list = this.props.LoadsList;
    return (
      <div className={cs(css.alertLoads)}>
        {!this.props.mathesLoadLoading && list && < Results
          query={{}}
          hasItems={true}
          total={list.total_shipments}
          results={list}
          sorting={false}
        />}
        {this.props.mathesLoadLoading && <div class='spinnerWrap'><Spinner /></div>}
      </div>
    )
  }
}

export default connect(({alert: {LoadsList, mathesLoadLoading}, loadsSearch}) => ({
  mathesLoadLoading,
  LoadsList,
  loadsSearch
}), mapDispatch({
  getLoads: (props, params) => getLoads(params),
}))(AlertLoads);



// WEBPACK FOOTER //
// ./src/components/Alert/LoadsList/index.js